import React from 'react';
import HTMLReactParser from 'html-react-parser';
import { Container, Row, Col } from 'react-bootstrap';
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import { GetURL } from "../../common/site/functions";
import { Link } from "@StarberryUtils";
import Google from "../../../images/google-reviews.png";
import "./SplitHeader.scss";
import axios from "axios";
import ImageModule from '../../common/Image_Module';
const SplitHeader = (props) => {
    const image_url = props.image.url
    let [averageRating, setAverageRating] = React.useState(0);
    let [reviewCount, setReviewCount] = React.useState(0);
	let processedImages = JSON.stringify({});
	if (props.imagetransforms?.Banner_Image_Transforms) {
		processedImages = props.imagetransforms?.Banner_Image_Transforms;
	}
    const wordToNumber = { 'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5 };
  const strapiconfig = {
    headers: {
        Authorization:
            `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    }}
    const getitems = async url => {
        try {
          const { data } = await axios.get(url,strapiconfig)// could be from env files 
          setReviewCount(data.length);
          let sumOfScores = 0;
          data.map((review) => {
            const reviewStringValue = review.starRating;
            sumOfScores += wordToNumber[reviewStringValue];
          })
          setAverageRating(Math.round(sumOfScores / data.length * 10) / 10);
        } catch (error) {
          // cache it if fail/error;
    
        }
      }
      if (props.pagename !== "Home" && props.rating == true) {
        getitems(`${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`);
      }
    return (
        <div className="split-header-wrapper sec-pdy-80">
            <Container>
                <Row>
                    <Col md={6} className="left-column split-header-content">
                            {props.title &&
								<h1 className="h2">{props.title}</h1>
							}
							{props.content &&
								<div className="banner-intro-text">
									{HTMLReactParser(props.content.replace(/\n/g, ''))}
								</div>
							}
							 {(props.cta_1 && props.cta_1_link) || (props.cta_2 && props.cta_2_link) ? (
                                <div className={`${props?.mobile_sticky ? 'd-none d-md-flex' : 'd-flex'} btn-wrapper`}>
                                {props.cta_1 && props.cta_1_link && (
                                    <Link to={`/${GetURL(props.cta_1_link.id)}`} className="btn btn-primary">
                                    {props.cta_1}
                                    </Link>
                                )}
                                {props.cta_2 && props.cta_2_link && (
                                    <Link to={`/${GetURL(props.cta_2_link.id)}`} className="btn btn-secondary">
                                    {props.cta_2}
                                    </Link>
                                )}
                                </div>
                            ) : null}
                            
                            {props.rating === true &&
                                <div className="google-review-rating">
                                <div className="img">
                                    <img loading="lazy" src={Google} alt="google-review - Dacha" />
                                </div>
                                <div className="review-rating-content">
                                    <p className="review-rating text-md-20-16">{averageRating}/5 Rating from {reviewCount} Reviews</p>
                                    {props.title !== 'Our client reviews' &&
                                        <Link className="text-sm review-more" href="/about-dacha/customer-testimonials/">View more reviews</Link>
                                    }
                                </div>
                                </div>
                            }
                    </Col>
                    <Col md={6} className="right-column">
                        <div className="img-wrapper img-zoom">
                         {/* <ImageTransform 
                         imagesources={image_url} 
                         renderer="srcSet" 
                         imagename="articles.Banner_Image.details" 
                         attr={{ alt: `${props.image.alternativeText} - Dacha`, class: '' }} 
                         imagetransformresult={processedImages} 
                         id={props.id} /> */}
                          <ImageModule 
                                ImageSrc={props?.image } 
                                attr={{ alt: props?.image?.alternativeText +' - Dacha', class: '' }} 
                                ggfx_results={props?.ggfx_results} 
                                imagename="articles.Banner_Image.details" 
                                strapi_id={props?.id} 
                            />
                        </div>		
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default SplitHeader;
